import { render, staticRenderFns } from "./AdminAddPromotion2026.vue?vue&type=template&id=609de1c8&scoped=true"
import script from "./AdminAddPromotion2026.vue?vue&type=script&lang=js"
export * from "./AdminAddPromotion2026.vue?vue&type=script&lang=js"
import style0 from "./AdminAddPromotion2026.vue?vue&type=style&index=0&id=609de1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609de1c8",
  null
  
)

export default component.exports